import { MODULE_NAME as CAMPAIGNS_MODULE } from 'modules/campaigns/config/routes/module';
import { COMMON_FLAGS, FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import * as FIELDS from '../../fields';
import { SPENT } from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import columnDefinitions from './columnDefinitions';
import { DCO_ITEM_PERFORMANCE_REPORT_ID } from './dcoItemPerformanceReportId';
import graph from './graph';
import { customColumns, performanceColumns, setupColumns, defaultColumns } from './reportPresets';

export const dcoByItemReportConfig = {
    id: DCO_ITEM_PERFORMANCE_REPORT_ID,
    label: 'DCO Item Performance',
    accountConfigurations: {
        [FEATURE_FLAGS.IS_DCO_ACCOUNT]: 'true',
    },
    commonConfigurations: {
        [COMMON_FLAGS.DCO_ITEM_PERFORMANCE_REPORT_ENABLED]: 'true',
    },
    module: CAMPAIGNS_MODULE,
    endpoint: 'dco-by-item-performance',
    graph,
    rowIdField: FIELDS.ITEM_ID.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
        [REPORT_PRESET.PERFORMANCE]: { columns: performanceColumns },
        [REPORT_PRESET.SETUP]: { columns: setupColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    footerColumnDef: [],
    isEmptyFooter: true,
    sortMap: {
        [SPENT.field]: SPENT.field,
    },
    searchPlaceholderMsgId: 'app.reports.dcoByItem.search.placeholder',
    searchField: FIELDS.ITEM_ID.field,
    filters: [],
    initialFilters: [],
    rowHeight: 62,
    comfortableRowHeight: 112,
};

export default dcoByItemReportConfig;
